import { ROUTE_SPORTSBOOK } from '../router/constants';
import * as Products from '../brand/products';

export const REDUCER_NAME = 'shop';

export const SHOP_GET_BONUS = 'SHOP_GET_BONUS';
export const SHOP_DETAIL_BONUS_VALID_PRODUCTS = 'SHOP_DETAIL_BONUS_VALID_PRODUCTS';
export const SHOP_DETAIL_BONUS_CLAIM_UNTIL = 'SHOP_DETAIL_BONUS_CLAIM_UNTIL';
export const SHOP_DETAIL_BONUS_DAYS_TO_PLAY = 'SHOP_DETAIL_BONUS_DAYS_TO_PLAY';
// export const SHOP_DETAIL_BONUS_MIN_AMOUNT = 'SHOP_DETAIL_BONUS_MIN_AMOUNT';
// export const SHOP_DETAIL_BONUS_MAX_AMOUNT = 'SHOP_DETAIL_BONUS_MAX_AMOUNT';
export const SHOP_DETAIL_BONUS_PERCENTAGE = 'SHOP_DETAIL_BONUS_PERCENTAGE';
// export const SHOP_DETAIL_BONUS_AMOUNT = 'SHOP_DETAIL_BONUS_AMOUNT';
export const SHOP_BONUS_REQUIREMENTS = 'SHOP_BONUS_REQUIREMENTS';
export const SHOP_CASINO_BONUS_REQUIREMENTS = 'SHOP_CASINO_BONUS_REQUIREMENTS';
export const SHOP_CASINO_BONUS_REQUIREMENT_X_FACTOR = 'SHOP_CASINO_BONUS_REQUIREMENT_X_FACTOR';
export const SHOP_SPORTS_BONUS_REQUIREMENTS = 'SHOP_SPORTS_BONUS_REQUIREMENTS';
export const SHOP_SPORTS_BONUS_REQUIREMENT_X_FACTOR = 'SHOP_SPORTS_BONUS_REQUIREMENT_X_FACTOR';
export const SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS = 'SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS';
export const SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS =
	'SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS';
export const SHOP_DETAIL_INSUFFICIENT_POINTS = 'SHOP_DETAIL_INSUFFICIENT_POINTS';
export const SHOP_GET_FREESPIN = 'SHOP_GET_FREESPIN';
export const SHOP_GET_FREEBET = 'SHOP_GET_FREEBET';
export const MOBILE_SHOP_BONUS_ITEM_COST = 'MOBILE_SHOP_BONUS_ITEM_COST';
export const MOBILE_SHOP_FREE_SPIN_ITEM_GAMES = 'MOBILE_SHOP_FREE_SPIN_ITEM_GAMES';
export const MOBILE_SHOP_FREE_SPIN_ITEM_COST = 'MOBILE_SHOP_FREE_SPIN_ITEM_COST';
export const MOBILE_SHOP_FREE_SPIN_ITEM_ROUNDS = 'MOBILE_SHOP_FREE_SPIN_ITEM_ROUNDS';
export const MOBILE_SHOP_FREE_SPIN_ITEM_EXPIRE = 'MOBILE_SHOP_FREE_SPIN_ITEM_EXPIRE';
export const MOBILE_SHOP_FREE_BET_ITEM_COST = 'MOBILE_SHOP_FREE_BET_ITEM_COST';
export const MOBILE_SHOP_FREE_BET_ITEM_AMOUNT = 'MOBILE_SHOP_FREE_BET_ITEM_AMOUNT';
export const MOBILE_SHOP_FREE_BET_ITEM_EXPIRE = 'MOBILE_SHOP_FREE_BET_ITEM_EXPIRE';
// export const MOBILE_SHOP_DETAIL_BUY_WITH_POINTS_HEADER =
// 	'MOBILE_SHOP_BUY_WITH_POINTS_HEADER';
// export const MOBILE_SHOP_DETAIL_BUY_WITH_POINTS_BUTTON =
// 	'MOBILE_SHOP_BUY_WITH_POINTS_BUTTON';
export const MOBILE_SHOP_BUY_WITH_POINTS = 'MOBILE_SHOP_BUY_WITH_POINTS';
export const CANCEL = 'CANCEL';
// export const MOBILE_SHOP_DETAIL_CONFIRM_BUY_WITH_POINTS =
// 	'MOBILE_SHOP_CONFIRM_BUY_WITH_POINTS';
// export const MOBILE_SHOP_READ_MORE_SUPPORT_LINK =
// 	'MOBILE_SHOP_READ_MORE_SUPPORT_LINK';
export const MOBILE_SHOP_DETAIL_MESSAGE_NOT_ENOUGH_POINTS = 'MOBILE_SHOP_DETAIL_MESSAGE_NOT_ENOUGH_POINTS';
export const MOBILE_SHOP_DETAIL_READ_MORE_BUTTON = 'MOBILE_SHOP_DETAIL_READ_MORE_BUTTON';
// export const MOBILE_SHOP_OK_BUTTON = 'MOBILE_SHOP_OK_BUTTON';
// export const MOBILE_SHOP_DETAIL_MESSAGE_NEED_MORE_POINTS =
// 	'MOBILE_SHOP_DETAIL_MESSAGE_NEED_MORE_POINTS';
export const MOBILE_MAIN_MENU_CASINO = 'MOBILE_MAIN_MENU_CASINO';
export const MOBILE_MAIN_MENU_SPORTS = 'MOBILE_MAIN_MENU_SPORTS';
export const MOBILE_VERIFY_MOBILE = 'MOBILE_VERIFY_MOBILE';
export const MOBILE_NOT_NOW = 'MOBILE_NOT_NOW';
// export const MOBILE_SHOP_DETAIL_FREESPIN_ADDED_MESSAGE =
// 	'MOBILE_SHOP_DETAIL_FREESPIN_ADDED_MESSAGE';
// export const MOBILE_SHOP_DETAIL_FREEBET_ADDED_MESSAGE =
// 	'MOBILE_SHOP_DETAIL_FREEBET_ADDED_MESSAGE';
// export const MOBILE_SHOP_DETAIL_SUCCESS_MESSAGE =
// 	'MOBILE_SHOP_DETAIL_SUCCESS_MESSAGE';
// export const MOBILE_SHOP_DETAIL_PLAY_FREESPIN_BUTTON =
// 	'MOBILE_SHOP_DETAIL_PLAY_FREESPIN_BUTTON';
// export const MOBILE_SHOP_DETAIL_PLAY_FREEBET_BUTTON =
// 	'MOBILE_SHOP_DETAIL_PLAY_FREEBET_BUTTON';
// export const MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER =
// 	'MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER';
// export const MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT =
// 	'MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT';
// export const MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE =
// 	'MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE';
// export const MOBILE_SHOP_DETAIL_CONFIRM_DEPOSIT =
// 	'MOBILE_SHOP_DETAIL_CONFIRM_DEPOSIT';
// export const MOBILE_SHOP_DETAIL_DEPOSIT_BUTTON =
// 	'MOBILE_SHOP_DETAIL_DEPOSIT_BUTTON';
export const BONUS_TURNOVER_TIMES_DEPOSIT = 'BONUS_TURNOVER_TIMES_DEPOSIT';
export const MOBILE_SHOP_MESSAGE = 'MOBILE_SHOP_MESSAGE';
export const MOBILE_SHOP_VOUCHER_BUTTON = 'MOBILE_SHOP_VOUCHER_BUTTON';
export const SIGNUP_ENTER_VOCUHER_CODE = 'SIGNUP_ENTER_VOCUHER_CODE'; // [sic]
export const WEB_EXCEPTION_1 = 'WEB_EXCEPTION_1';
export const SHOP_LOGGED_OUT_HEADER = 'SHOP_LOGGED_OUT_HEADER';
export const SHOP_LOGGED_OUT_MESSAGE = 'SHOP_LOGGED_OUT_MESSAGE';
export const MOBILE_MAIN_MENU_SHOP = 'MOBILE_MAIN_MENU_SHOP';
export const MOBILE_MAIN_MENU_SHOP_EXTERNAL = 'MOBILE_MAIN_MENU_SHOP_EXTERNAL';
export const SHOP_EXTERNAL_NEW = 'SHOP_EXTERNAL_NEW';
export const MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_HEADER = 'MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_HEADER';
export const MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_TEXT = 'MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_TEXT';
export const MOBILE_MY_ACTIVE_BONUSES = 'MOBILE_MY_ACTIVE_BONUSES';
export const MOBILE_MY_BONUS_ACTIVE_TAB = 'MOBILE_MY_BONUS_ACTIVE_TAB';
export const MOBILE_MY_BONUS_HISTORY_TAB = 'MOBILE_MY_BONUS_HISTORY_TAB';
export const MOBILE_HEADER_NO_ACTIVE_BONUSES = 'MOBILE_HEADER_NO_ACTIVE_BONUSES';
export const MOBILE_NO_ACTIVE_OFFERS_TEXT = 'MOBILE_NO_ACTIVE_OFFERS_TEXT';
export const MOBILE_BUTTON_BONUS_SHOW_DETAIL = 'MOBILE_BUTTON_BONUS_SHOW_DETAIL';
export const MOBILE_BUTTON_BONUS_CANCEL_BONUS = 'MOBILE_BUTTON_BONUS_CANCEL_BONUS';
export const MOBILE_HEADER_BONUSCANCEL_CANCELBONUS = 'MOBILE_HEADER_BONUSCANCEL_CANCELBONUS';
export const MOBILE_TEXT_BONUSCANCEL_BONUSAMOUNT = 'MOBILE_TEXT_BONUSCANCEL_BONUSAMOUNT';
export const MOBILE_BUTTON_BONUSCANCEL_YES = 'MOBILE_BUTTON_BONUSCANCEL_YES';
export const MOBILE_BUTTON_BONUSCANCEL_NO = 'MOBILE_BUTTON_BONUSCANCEL_NO';
export const BUTTON_CANCEL = 'BUTTON_CANCEL';
export const MOBILE_ACTIVE_BONUS_SHOP_BUTTON_TEXT = 'MOBILE_ACTIVE_BONUS_SHOP_BUTTON_TEXT';
export const MOBILE_HISTORICAL_BONUS_SHOP_BUTTON_TEXT = 'MOBILE_HISTORICAL_BONUS_SHOP_BUTTON_TEXT';
export const MOBILE_HEADER_BONUS_END_DATE = 'MOBILE_HEADER_BONUS_END_DATE';
export const MOBILE_BONUS_CANCEL_SUCCESS = 'MOBILE_BONUS_CANCEL_SUCCESS';
export const SHOP_CLOSED_TITLE = 'SHOP_CLOSED_TITLE';
export const SHOP_CLOSED_INFO = 'SHOP_CLOSED_INFO';
export const SHOP_SITE_TITLE = 'SHOP_SITE_TITLE';
export const TODAY = 'TODAY';
export const POINTS = 'POINTS';
export const SHOP_LOTTERY_SUCCESSFUL_ENTRY_TEXT = 'SHOP_LOTTERY_SUCCESSFUL_ENTRY_TEXT';
export const SHOP_LOTTERY_POINTS_NOTIFICATION = 'SHOP_LOTTERY_POINTS_NOTIFICATION';
export const SHOP_LOTTERY_DAY_REMAINING = 'SHOP_LOTTERY_DAY_REMAINING';
export const SHOP_LOTTERY_DAYS_REMAINING = 'SHOP_LOTTERY_DAYS_REMAINING';
export const SHOP_LOTTERY_WINNER_CONTINUE = 'SHOP_LOTTERY_WINNER_CONTINUE';
export const SHOP_LOTTERY_WINNER_DESCRIPTION = 'SHOP_LOTTERY_WINNER_DESCRIPTION';
export const SHOP_LOTTERY_WINNER_DISMISS = 'SHOP_LOTTERY_WINNER_DISMISS';
export const SHOP_LOTTERY_WINNER_HEADER = 'SHOP_LOTTERY_WINNER_HEADER';
export const SHOP_LOTTERY_ENDED = 'SHOP_LOTTERY_ENDED';
export const SHOP_LOTTERY_BUY_MORE = 'SHOP_LOTTERY_BUY_MORE';
export const SHOP_LOTTERY_CHECK_OUT_OTHER_SHOP_ITEMS = 'SHOP_LOTTERY_CHECK_OUT_OTHER_SHOP_ITEMS';
export const SHOP_POINTS_FAQ = 'SHOP_POINTS_FAQ';
export const SHOP_LOTTERY_POINTS_FAQ_MESSAGE = 'SHOP_LOTTERY_POINTS_FAQ_MESSAGE';
export const SHOP_LOTTERY_POINTS_FAQ_TITLE = 'SHOP_LOTTERY_POINTS_FAQ_TITLE';
export const SHOP_LOTTERY_HAS_BEEN_DRAWN = 'SHOP_LOTTERY_HAS_BEEN_DRAWN';
export const SHOP_LOTTERY_FAQ_TITLE = 'SHOP_LOTTERY_FAQ_TITLE';
export const SHOP_LOTTERY_FAQ_DESCRIPTION = 'SHOP_LOTTERY_FAQ_DESCRIPTION';
export const SHOP_LOTTERY_FAQ_BLOCK_ONE_TITLE = 'SHOP_LOTTERY_FAQ_BLOCK_ONE_TITLE';
export const SHOP_LOTTERY_FAQ_BLOCK_ONE_DESCRIPTION = 'SHOP_LOTTERY_FAQ_BLOCK_ONE_DESCRIPTION';
export const SHOP_LOTTERY_FAQ_BLOCK_TWO_TITLE = 'SHOP_LOTTERY_FAQ_BLOCK_TWO_TITLE';
export const SHOP_LOTTERY_FAQ_BLOCK_TWO_DESCRIPTION = 'SHOP_LOTTERY_FAQ_BLOCK_TWO_DESCRIPTION';
export const SHOP_LOTTERY_FAQ_BLOCK_THREE_TITLE = 'SHOP_LOTTERY_FAQ_BLOCK_THREE_TITLE';
export const SHOP_LOTTERY_FAQ_BLOCK_THREE_DESCRIPTION = 'SHOP_LOTTERY_FAQ_BLOCK_THREE_DESCRIPTION';
export const SHOP_LOTTERY_FAQ_BLOCK_FOUR_TITLE = 'SHOP_LOTTERY_FAQ_BLOCK_FOUR_TITLE';
export const SHOP_LOTTERY_FAQ_BLOCK_FOUR_DESCRIPTION = 'SHOP_LOTTERY_FAQ_BLOCK_FOUR_DESCRIPTION';
export const SHOP_LOTTERY_YOU_WIN = 'SHOP_LOTTERY_YOU_WIN';
export const SHOP_LOTTERY_YOU_LOST = 'SHOP_LOTTERY_YOU_LOST';
export const SHOP_LOTTERY_DRAW = 'SHOP_LOTTERY_DRAW';
export const SHOP_LOTTERY_DRAW_DATE = 'SHOP_LOTTERY_DRAW_DATE';
export const SHOP_LOTTERY_DRAW_TIME = 'SHOP_LOTTERY_DRAW_TIME';
export const SHOP_LOTTERY_COST = 'SHOP_LOTTERY_COST';
export const SHOP_LOTTERY_TOTAL_ENTRIES = 'SHOP_LOTTERY_TOTAL_ENTRIES';
export const SHOP_LOTTERY_MY_ENTRIES = 'SHOP_LOTTERY_MY_ENTRIES';
export const SHOP_LOTTERY_DETAILS = 'SHOP_LOTTERY_DETAILS';
export const SHOP_LOTTERY_PRIZES = 'SHOP_LOTTERY_PRIZES';
export const SHOP_LOTTERY_NOTIFICATION_INFORMATION = 'SHOP_LOTTERY_NOTIFICATION_INFORMATION';
export const SHOP_LOTTERY_POINT_BALANCE = 'SHOP_LOTTERY_POINT_BALANCE';
export const SHOP_LOTTERY_TOTAL_COST = 'SHOP_LOTTERY_TOTAL_COST';
export const SHOP_LOTTERY_TICKET_AMOUNT = 'SHOP_LOTTERY_TICKET_AMOUNT';
export const SHOP_LOTTERY_AMOUNT_MODAL_PAGE_HEADER_TITLE = 'SHOP_LOTTERY_AMOUNT_MODAL_PAGE_HEADER_TITLE';
export const SHOP_LOTTERY_AMOUNT_MODAL_EDIT_AMOUNT = 'SHOP_LOTTERY_AMOUNT_MODAL_EDIT_AMOUNT';
export const SHOP_LOTTERY_TICKET_PRICE = 'SHOP_LOTTERY_TICKET_PRICE';
export const SHOP_LOTTERY_ALL_WINNERS = 'SHOP_LOTTERY_ALL_WINNERS';
export const SHOP_LOTTERY_YOU_WON = 'SHOP_LOTTERY_YOU_WON';
export const SHOP_BONUSES = 'SHOP_BONUSES';
export const MOBILE_LOAD_MORE = 'MOBILE_LOAD_MORE';
export const MY_ACTIVITIES_HISTORICAL_SELECT_DEFAULT = 'MY_ACTIVITIES_HISTORICAL_SELECT_DEFAULT';
export const LOTTERIES_COMEON_SHOP = 'LOTTERIES_COMEON_SHOP';
export const SHOP_FILTER_PILL_AFFORDABLE = 'SHOP_FILTER_PILL_AFFORDABLE';
export const SHOP_FILTER_PILL_BONUSES = 'SHOP_FILTER_PILL_BONUSES';
export const SHOP_POINTS_BALANCE_LABEL_LOGGED_OUT = 'SHOP_POINTS_BALANCE_LABEL_LOGGED_OUT';
export const SHOP_POINTS_BALANCE_LABEL_LOGGED_IN = 'SHOP_POINTS_BALANCE_LABEL_LOGGED_IN';
export const META_KEYWORDS_SHOP = 'META_KEYWORDS_SHOP';
export const META_DESCRIPTION_SHOP = 'META_DESCRIPTION_SHOP';
export const SHOP_NO_AVAILABLE_ITEMS_TITLE = 'SHOP_NO_AVAILABLE_ITEMS_TITLE';
export const SHOP_NO_AVAILABLE_ITEMS_SUBTITLE = 'SHOP_NO_AVAILABLE_ITEMS_SUBTITLE';
export const SHOP_INFO_BANNER_POINTS = 'SHOP_INFO_BANNER_POINTS';
export const SHOP_INFO_BANNER_LEVEL = 'SHOP_INFO_BANNER_LEVEL';
export const SHOP_INFO_BANNER_IMG = 'SHOP_INFO_BANNER_IMG';
export const SHOP_INFO_BANNER_IMG_BRONZE = 'SHOP_INFO_BANNER_IMG_BRONZE';
export const SHOP_INFO_BANNER_IMG_SILVER = 'SHOP_INFO_BANNER_IMG_SILVER';
export const SHOP_INFO_BANNER_IMG_GOLD = 'SHOP_INFO_BANNER_IMG_GOLD';
export const SHOP_INFO_BANNER_IMG_PLATINUM = 'SHOP_INFO_BANNER_IMG_PLATINUM';
export const SHOP_INFO_BANNER_IMG_DIAMOND = 'SHOP_INFO_BANNER_IMG_DIAMOND';
export const SHOP_INFO_BANNER_IMG_DIAMOND_PLUS = 'SHOP_INFO_BANNER_IMG_DIAMOND_PLUS';
export const SHOP_TIER_LEVEL_NOT_AVAILABLE = 'SHOP_TIER_LEVEL_NOT_AVAILABLE';
export const DEPOSIT_OPT_IN_PROMO_ITEM = 'DEPOSIT_OPT_IN_PROMO_ITEM';
export const SHOP_SPECIALS = 'SHOP_SPECIALS';
export const SHOP_CARD_WAGERING = 'SHOP_CARD_WAGERING';
export const SHOP_CARD_WAGERING_REQUIRED = 'SHOP_CARD_WAGERING_REQUIRED';
export const SHOP_SALE_ENDS = 'SHOP_SALE_ENDS';
export const SHOP_DAYS_ABBREVIATION = 'SHOP_DAYS_ABBREVIATION';
export const SHOP_HOURS_ABBREVIATION = 'SHOP_HOURS_ABBREVIATION';
export const SHOP_MINUTES_ABBREVIATION = 'SHOP_MINUTES_ABBREVIATION';
export const SHOP_SECONDS_ABBREVIATION = 'SHOP_SECONDS_ABBREVIATION';

export const SPORTSBOOK_SUPER_BOOST_ODD_VALUE = 'SPORTSBOOK_SUPER_BOOST_ODD_VALUE';

export const TEXT_KEYS = [
	SHOP_GET_BONUS,
	SHOP_DETAIL_BONUS_VALID_PRODUCTS,
	SHOP_DETAIL_BONUS_PERCENTAGE,
	SHOP_DETAIL_BONUS_DAYS_TO_PLAY,
	SHOP_BONUS_REQUIREMENTS,
	SHOP_LOGGED_OUT_HEADER,
	SHOP_LOGGED_OUT_MESSAGE,
	SHOP_CASINO_BONUS_REQUIREMENTS,
	SHOP_CASINO_BONUS_REQUIREMENT_X_FACTOR,
	SHOP_SPORTS_BONUS_REQUIREMENTS,
	SHOP_SPORTS_BONUS_REQUIREMENT_X_FACTOR,
	SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_ODDS,
	SHOP_SPORTS_BONUS_REQUIREMENT_BET_MINIMUM_SELECTIONS,
	SHOP_DETAIL_INSUFFICIENT_POINTS,
	SHOP_GET_FREESPIN,
	SHOP_GET_FREEBET,
	MOBILE_SHOP_BONUS_ITEM_COST,
	MOBILE_SHOP_FREE_SPIN_ITEM_GAMES,
	MOBILE_SHOP_FREE_SPIN_ITEM_COST,
	MOBILE_SHOP_FREE_SPIN_ITEM_ROUNDS,
	MOBILE_SHOP_FREE_SPIN_ITEM_EXPIRE,
	MOBILE_SHOP_FREE_BET_ITEM_COST,
	MOBILE_SHOP_FREE_BET_ITEM_AMOUNT,
	MOBILE_SHOP_FREE_BET_ITEM_EXPIRE,
	MOBILE_SHOP_BUY_WITH_POINTS,
	CANCEL,
	MOBILE_SHOP_DETAIL_MESSAGE_NOT_ENOUGH_POINTS,
	MOBILE_SHOP_DETAIL_READ_MORE_BUTTON,
	MOBILE_MAIN_MENU_SHOP,
	MOBILE_MAIN_MENU_SHOP_EXTERNAL,
	SHOP_EXTERNAL_NEW,
	MOBILE_MAIN_MENU_CASINO,
	MOBILE_MAIN_MENU_SPORTS,
	MOBILE_VERIFY_MOBILE,
	MOBILE_NOT_NOW,
	BONUS_TURNOVER_TIMES_DEPOSIT,
	MOBILE_SHOP_MESSAGE,
	MOBILE_SHOP_VOUCHER_BUTTON,
	SIGNUP_ENTER_VOCUHER_CODE, // [sic]
	WEB_EXCEPTION_1,
	MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_HEADER,
	MOBILE_SHOP_NOT_AVAILABLE_AS_GUEST_TEXT,
	MOBILE_MY_ACTIVE_BONUSES,
	MOBILE_MY_BONUS_ACTIVE_TAB,
	MOBILE_MY_BONUS_HISTORY_TAB,
	MOBILE_HEADER_NO_ACTIVE_BONUSES,
	MOBILE_NO_ACTIVE_OFFERS_TEXT,
	MOBILE_BUTTON_BONUS_SHOW_DETAIL,
	MOBILE_BUTTON_BONUS_CANCEL_BONUS,
	MOBILE_HEADER_BONUSCANCEL_CANCELBONUS,
	MOBILE_TEXT_BONUSCANCEL_BONUSAMOUNT,
	MOBILE_BUTTON_BONUSCANCEL_YES,
	MOBILE_BUTTON_BONUSCANCEL_NO,
	BUTTON_CANCEL,
	MOBILE_ACTIVE_BONUS_SHOP_BUTTON_TEXT,
	MOBILE_HISTORICAL_BONUS_SHOP_BUTTON_TEXT,
	MOBILE_HEADER_BONUS_END_DATE,
	MOBILE_BONUS_CANCEL_SUCCESS,
	TODAY,
	POINTS,
	SHOP_CLOSED_INFO,
	SHOP_CLOSED_TITLE,
	SHOP_SITE_TITLE,
	SHOP_POINTS_FAQ,
	SHOP_LOTTERY_SUCCESSFUL_ENTRY_TEXT,
	SHOP_LOTTERY_POINTS_NOTIFICATION,
	SHOP_LOTTERY_DAY_REMAINING,
	SHOP_LOTTERY_DAYS_REMAINING,
	SHOP_LOTTERY_WINNER_HEADER,
	SHOP_LOTTERY_WINNER_CONTINUE,
	SHOP_LOTTERY_WINNER_DISMISS,
	SHOP_LOTTERY_WINNER_DESCRIPTION,
	SHOP_LOTTERY_ENDED,
	SHOP_LOTTERY_BUY_MORE,
	SHOP_LOTTERY_CHECK_OUT_OTHER_SHOP_ITEMS,
	SHOP_LOTTERY_POINTS_FAQ_MESSAGE,
	SHOP_LOTTERY_POINTS_FAQ_TITLE,
	SHOP_LOTTERY_HAS_BEEN_DRAWN,
	SHOP_LOTTERY_FAQ_TITLE,
	SHOP_LOTTERY_FAQ_DESCRIPTION,
	SHOP_LOTTERY_FAQ_BLOCK_ONE_TITLE,
	SHOP_LOTTERY_FAQ_BLOCK_ONE_DESCRIPTION,
	SHOP_LOTTERY_FAQ_BLOCK_TWO_TITLE,
	SHOP_LOTTERY_FAQ_BLOCK_TWO_DESCRIPTION,
	SHOP_LOTTERY_FAQ_BLOCK_THREE_TITLE,
	SHOP_LOTTERY_FAQ_BLOCK_THREE_DESCRIPTION,
	SHOP_LOTTERY_FAQ_BLOCK_FOUR_TITLE,
	SHOP_LOTTERY_FAQ_BLOCK_FOUR_DESCRIPTION,
	SHOP_LOTTERY_YOU_WIN,
	SHOP_LOTTERY_YOU_LOST,
	SHOP_LOTTERY_DRAW,
	SHOP_LOTTERY_DRAW_DATE,
	SHOP_LOTTERY_DRAW_TIME,
	SHOP_LOTTERY_COST,
	SHOP_LOTTERY_TOTAL_ENTRIES,
	SHOP_LOTTERY_MY_ENTRIES,
	SHOP_LOTTERY_DETAILS,
	SHOP_LOTTERY_NOTIFICATION_INFORMATION,
	SHOP_LOTTERY_POINT_BALANCE,
	SHOP_LOTTERY_TOTAL_COST,
	SHOP_LOTTERY_TICKET_AMOUNT,
	SHOP_LOTTERY_AMOUNT_MODAL_PAGE_HEADER_TITLE,
	SHOP_LOTTERY_AMOUNT_MODAL_EDIT_AMOUNT,
	SHOP_LOTTERY_TICKET_PRICE,
	SHOP_LOTTERY_PRIZES,
	SHOP_LOTTERY_ALL_WINNERS,
	SHOP_LOTTERY_YOU_WON,
	SHOP_BONUSES,
	MOBILE_LOAD_MORE,
	MY_ACTIVITIES_HISTORICAL_SELECT_DEFAULT,
	LOTTERIES_COMEON_SHOP,
	SHOP_FILTER_PILL_AFFORDABLE,
	SHOP_FILTER_PILL_BONUSES,
	SHOP_POINTS_BALANCE_LABEL_LOGGED_OUT,
	SHOP_POINTS_BALANCE_LABEL_LOGGED_IN,
	META_KEYWORDS_SHOP,
	META_DESCRIPTION_SHOP,
	SHOP_NO_AVAILABLE_ITEMS_TITLE,
	SHOP_NO_AVAILABLE_ITEMS_SUBTITLE,
	SHOP_INFO_BANNER_POINTS,
	SHOP_INFO_BANNER_LEVEL,
	SHOP_DETAIL_BONUS_CLAIM_UNTIL,
	SHOP_TIER_LEVEL_NOT_AVAILABLE,
	SPORTSBOOK_SUPER_BOOST_ODD_VALUE,
	DEPOSIT_OPT_IN_PROMO_ITEM,
	SHOP_SPECIALS,
	SHOP_CARD_WAGERING,
	SHOP_CARD_WAGERING_REQUIRED,
	SHOP_SALE_ENDS,
	SHOP_DAYS_ABBREVIATION,
	SHOP_HOURS_ABBREVIATION,
	SHOP_MINUTES_ABBREVIATION,
	SHOP_SECONDS_ABBREVIATION
];

export const CasinoButton = {
	onClick: ({ casinoRoute }: { casinoRoute: string }) => {
		window.location.assign(casinoRoute);
	},
	textKey: MOBILE_MAIN_MENU_CASINO
};

export const SportsbookButton = {
	onClick: () => {
		window.location.assign(ROUTE_SPORTSBOOK);
	},
	textKey: MOBILE_MAIN_MENU_SPORTS
};

export const getButtonsForProducts = (products: string[]) => {
	const buttons = [];
	const hasProduct = (product: string) => products.some(item => item.toLowerCase() === product.toLowerCase());

	if (hasProduct(Products.CASINO)) {
		buttons.push(CasinoButton);
	}
	if (hasProduct(Products.SPORTSBOOK)) {
		buttons.push(SportsbookButton);
	}

	return buttons;
};

export const RESOURCE_KEYS = [
	SHOP_INFO_BANNER_IMG,
	SHOP_INFO_BANNER_IMG_BRONZE,
	SHOP_INFO_BANNER_IMG_SILVER,
	SHOP_INFO_BANNER_IMG_GOLD,
	SHOP_INFO_BANNER_IMG_PLATINUM,
	SHOP_INFO_BANNER_IMG_DIAMOND,
	SHOP_INFO_BANNER_IMG_DIAMOND_PLUS
];

// Copies from sportsbook
export enum StaleTime {
	ZERO = 0, // Should be used as default for all requests (Always fresh data on demand).
	// Uncomment and use others only if you know what you are doing.
	THIRTY_SECONDS = 30 * 1000, // 30 seconds
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000 // 15 minutes
	// INFINITE = Infinity // Never expires
}

export enum RefetchInterval {
	SHORT = 60 * 1000, // 1 minute
	MODERATE = 5 * 60 * 1000, // 5 minutes
	LONG = 15 * 60 * 1000 // 15 minutes
}

// Following Textkeys are to be removed in BO due to duplicates / not being used
// MOBILE_SHOP_DETAIL_PLAY_FREESPIN_BUTTON,
// MOBILE_SHOP_DETAIL_PLAY_FREEBET_BUTTON,
// MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER,
// MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_HEADER_TEXT,
// MOBILE_FREE_MONEY_BONUS_REDEEM_SUCCESS_MESSAGE,
// MOBILE_SHOP_DETAIL_CONFIRM_DEPOSIT,
// MOBILE_SHOP_DETAIL_DEPOSIT_BUTTON,
// SHOP_DETAIL_BONUS_CLAIM_UNTIL,
// SHOP_DETAIL_BONUS_MIN_AMOUNT,
// SHOP_DETAIL_BONUS_MAX_AMOUNT,
// SHOP_DETAIL_BONUS_AMOUNT,
// MOBILE_SHOP_DETAIL_FREESPIN_ADDED_MESSAGE,
// MOBILE_SHOP_DETAIL_FREEBET_ADDED_MESSAGE,
// MOBILE_SHOP_DETAIL_SUCCESS_MESSAGE,
// MOBILE_SHOP_DETAIL_BUY_WITH_POINTS_HEADER,
// MOBILE_SHOP_DETAIL_BUY_WITH_POINTS_BUTTON,
// MOBILE_SHOP_OK_BUTTON,
// MOBILE_SHOP_DETAIL_MESSAGE_NEED_MORE_POINTS,
// MOBILE_SHOP_DETAIL_CONFIRM_BUY_WITH_POINTS,
// MOBILE_SHOP_READ_MORE_SUPPORT_LINK,
